import { QueryClient } from '@tanstack/react-query';

/** Shared TanStack Query client. Module-level singleton so non-React
 * code (e.g. the subtasks store's SSE handler) can invalidate queries
 * without round-tripping through `useQueryClient`. App.tsx still
 * passes this same instance to `QueryClientProvider`. */
export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: 1,
            refetchOnWindowFocus: false,
            // Avoid stampede on remount; mutations explicitly invalidate, so a
            // 30s baseline doesn't compromise freshness of post-write reads.
            staleTime: 30_000,
        },
    },
});
